import React, {useEffect, useState} from "react";
import Th_title from "../../../../components/Th_title";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {PageHeader} from "../../../../components/PageHeader";
import {skeleton} from "../../../../redux/slice/apiSlice";
import {getBulletinboard, removeBulletinboards} from "../../../../api/bulletinboard/BulletinboardService";
import {
    ContentDetailTwoColLayout,
    DetailFilePanel,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
    DetailSummaryListButton,
} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";
import "../../fieldMng/shared/codeManageSettings.css";
import {SettingsContentHeroActions} from "../../shared/SettingsContentHeroActions";

function BulletinboardInfo() {
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [bulletinboardData, setBulletinboardData] = useState();

    useEffect(() => {
        if (!id) return;
        setBulletinboardData(undefined);
        getBulletinboard(id).then((response) => {
            setBulletinboardData(response.data);
        }).finally(
            dispatch(skeleton(false))
        );
    }, [id, dispatch]);

    const listUrl = `/settings/bulletinboardlist/${bulletinboardData?.gubun}`;

    const handleMoveToEdit = () => {
        if (window.confirm("[수정페이지] 이동하시겠습니까?")) {
            navigate(`/settings/bulletinboard/update/${id}`);
        }
    };

    const handleRemove = async () => {
        if (!window.confirm("삭제 하시겠습니까?")) {
            return;
        }
        try {
            const response = await removeBulletinboards({ids: [id]});
            if (response.status === 200) {
                alert("작업이 정상적으로 삭제되었습니다.");
                navigate(listUrl);
            }
        } catch (error) {
            if (error.response?.status === 403) {
                alert("삭제할 권한이 없습니다.");
            }
        }
    };

    if (!bulletinboardData) {
        return null;
    }

    const headerActions = (
        <SettingsContentHeroActions>
            <DetailSummaryButton onClick={handleMoveToEdit}>수정</DetailSummaryButton>
            <DetailSummaryButton danger onClick={handleRemove}>삭제</DetailSummaryButton>
            <DetailSummaryListButton url={listUrl}>목록</DetailSummaryListButton>
        </SettingsContentHeroActions>
    );

    const mainPanel = (
        <DetailPanel title="기본정보">
            <DetailKvTable>
                <tbody>
                <tr>
                    <Th_title title="등록일시" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="createdAt"
                            data={{data: bulletinboardData, setData: setBulletinboardData}}
                            value={bulletinboardData.createdAt}
                        />
                    </Th_title>
                    <Th_title title="등록자" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="createdBy"
                            data={{data: bulletinboardData, setData: setBulletinboardData}}
                            value={bulletinboardData.createdBy}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="수정일시" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="updatedAt"
                            data={{data: bulletinboardData, setData: setBulletinboardData}}
                            value={bulletinboardData.updatedAt}
                        />
                    </Th_title>
                    <Th_title title="수정자" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="updatedBy"
                            data={{data: bulletinboardData, setData: setBulletinboardData}}
                            value={bulletinboardData.updatedBy}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="제목" colspan={3} className="fieldset-td" required={true}>
                        <ReadOnlyInputBasic
                            target="subject"
                            data={{data: bulletinboardData, setData: setBulletinboardData}}
                            value={bulletinboardData.subject}
                        />
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="내용" colspan={3} className="fieldset-td">
                        <div className="align-text-div">{bulletinboardData.content}</div>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const filePanel = (
        <DetailFilePanel
            title="파일"
            isEditing={false}
            tableInfo={{tableName: "bulletinboard", joinKey: id}}
        />
    );

    return (
        <div className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout flex min-h-0 flex-1 flex-col code-manage-scope">
            {bulletinboardData.gubun === "request"
                ? (
                    <PageHeader
                        header="요청자료실"
                        indicator="서비스요청 > 요청자료실 > 상세"
                        headerActions={headerActions}
                    />
                )
                : (
                    <PageHeader
                        header="자료실"
                        indicator="환경설정 > 알람관리 > 자료실 > 상세"
                        headerActions={headerActions}
                    />
                )}

            <DetailListPage className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailTwoColLayout main={mainPanel} aside={filePanel}/>
                </div>
            </DetailListPage>
        </div>
    );
}

export {BulletinboardInfo};
